import React, {useCallback, useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router";
import {useTranslation} from 'react-i18next';
import Modal from '../../components/Modal';
import {AxiosError} from 'axios';
import {Location} from 'history';
import client from 'lib/CommonApi/client';
import {callAlertWeb, callNativeWeb, footerShowEventWeb, hideProgressWeb, showProgressWeb} from 'common/appInterface';

const TemporaryFreezePage: React.FC = () => {
	/** Location State */
	const location = useLocation() as Location<LocationState>;
	/** Navigate */
	const navigate = useNavigate();
	/** 다국어처리 */
	const {t, i18n} = useTranslation();
	
	const screenId = "SERV11";
	const screenName = t("SERV11.title");
	
	const cardInfo = location.state.info;
	const [cardAccidentState, setCardAccidentState] = useState<CardAccidentState>();
	
	const [isLoad, setLoad] = useState(false);
	
	const [isFreezeModal, setFreezeModal] = useState(false);
	
	/** 뒤로가기 처리 (backKeyEvent_App (APP > WEB)) */
	const callbackBackkeyEvent = useCallback(() => {
		if (location.state.linkOpenMenu === 'main') {
			navigate("/main", {
				state: {
					query: location.state.query
					, swiperIndex: location.state.swiperIndex
					, tabIndex: location.state.tabIndex
					, from: location.pathname
				}
			});
		} else {
			navigate(-1);
		}
	}, [navigate, location.state.linkOpenMenu, location.state.query, location.state.swiperIndex, location.state.tabIndex, location.pathname]);
	
	/** 카드사고조회 */
	const callCardAccidentState = useCallback(async () => {
		showProgressWeb();
		setLoad(true);
		
		await client.get("/api/app/manage/accident/state", {
			params: {
				...location.state.query,
				alternativeCardNo: cardInfo.alternativeCardNo
			}
		}).then(response => {
			setCardAccidentState(response.data.response);
			setLoad(false);
		}).catch((e: AxiosError) => {
			callAlertWeb("ERROR", "99", e.message);
		}).finally(() => {
			hideProgressWeb();
		});
	}, [cardInfo.alternativeCardNo, location.state.query]);
	
	/** 사고등해제 호출 */
	const callAccident = useCallback(async (code: string) => {
		showProgressWeb();
		setLoad(true);
		
		await client.post("/api/app/accident/cardAccident", {
			...location.state.query,
			alternativeCardNo: cardInfo.alternativeCardNo,
			cardAccidentCode: code
		}).then((response) => {
			callCardAccidentState();
			
			// 정상
			if (response.data.code === "00") {
				// 일시정지
				if (code.startsWith("07")) {
					setFreezeModal(true);
				}
			} else {
				callAlertWeb("ERROR", response.data.code, response.data.message);
			}
		}).catch((e: AxiosError) => {
			callAlertWeb("ERROR", "99", e.message);
		}).finally(() => {
			setLoad(false);
			hideProgressWeb();
		});
	}, [location.state.query, cardInfo.alternativeCardNo, callCardAccidentState]);
	
	/** 일시정지 모달닫기 */
	const closeFreezeModal = () => {
		setFreezeModal(false);
	};
	
	// 최초실행
	useEffect(() => {
		// 언어설정
		i18n.changeLanguage(location.state.query.languageCode);
		// callNative_Web 처리 (WEB > APP)
		callNativeWeb(screenId, screenName, location.state.from === "/intro" ? 'Y' : 'N');
		// 하단바 숨기기
		footerShowEventWeb("N");
		
		console.log("QUERY STATE");
		console.log(location.state);
		console.log(cardInfo);
		
		callCardAccidentState();
		
		// 최초한번실행 useEffect() Warning 제거
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	// 뒤로가기 이벤트 리스너 (backKeyEvent_App (APP > WEB))
	useEffect(() => {
		document.addEventListener("backpress", callbackBackkeyEvent);
		return () => document.removeEventListener("backpress", callbackBackkeyEvent);
	}, [callbackBackkeyEvent]);
	
	return (
		<section className="contents pdt20">
			<div id="container">
				<div className="singUpWrapSub">
					<div className="inputBoxTy01">
						<label>
							<input placeholder=" " type="text" value={cardInfo.cardNo} readOnly/>
							<span>{t("SERV11.header01")}</span>
						</label>
					</div>
				</div>
				<div className="listtyp01">
					<div className="inner">
						<section className="manage">
							<p className="tit">{t("SERV11.explan01")}</p>
							<div className={cardAccidentState?.stopYn === 'Y' ? "listbox on" : "listbox"}>
								<div className="radioBox">
									<div className="g-pay">
										<p>{t("SERV11.header02")}</p>
										<p><small>{t("SERV11.explan02")}</small></p>
										<div className="toggleBox">
											<div className="inputBox">
												<input type="checkbox" id="toggle01"
													   checked={cardAccidentState?.stopYn === 'Y'}
													   onChange={() => callAccident(cardAccidentState?.stopYn === "Y" ? "079" : "071")}
													   disabled={isLoad}
												/>
												<span/>
												<label htmlFor="toggle01"/>
											</div>
										</div>
									</div>
								</div>
							</div>
							{cardInfo.membershipFeeCode !== "0" && (
								<p className="tit">{t("SERV11.explan03")}</p>
							)}
						</section>
					</div>
				</div>
			</div>
			{/* 일시정지 */}
			<Modal isOpen={isFreezeModal} contentLabel="modal" onRequestClose={closeFreezeModal} className="popTyLayer2"
				   overlayClassName="dim" closeTimeoutMS={0}
			>
				<p className="message">{t(`SERV11.popupExplan01.${cardAccidentState?.stopYn}`)}</p>
				<dl>
					<dd><span>{cardInfo.cardNo}</span></dd>
				</dl>
				<div className="btnWrapTy02">
					<button type="button" className="btnPrimaryTy01" onClick={closeFreezeModal}>
						<span>{t("COMMON.button.confirm")}</span></button>
				</div>
			</Modal>
		</section>
	);
};

export default TemporaryFreezePage;